const fr = {
  common: {
    appName: "VytaliDays", loading: "Chargement…", save: "Enregistrer", cancel: "Annuler",
    delete: "Supprimer", edit: "Modifier", create: "Créer", close: "Fermer", confirm: "Confirmer",
    back: "Retour", search: "Rechercher", none: "Aucun", yes: "Oui", no: "Non", reason: "Raison",
    submit: "Soumettre", actions: "Actions", points: "points", optional: "facultatif",
    language: "Langue", logout: "Déconnexion", saved: "Enregistré", required: "Requis",
    share: "Partager", start: "Début", end: "Fin", copyLink: "Copier le lien",
    linkCopied: "Lien copié", sending: "Envoi…",
  },
  auth: {
    signIn: "Se connecter", email: "Courriel", password: "Mot de passe",
    tagline: "Plateforme d'activation des ambassadeurs",
    inviteOnly: "Accès sur invitation seulement",
    welcome: "Bon retour", acceptTitle: "Activer votre compte",
    choosePassword: "Choisissez un mot de passe", passwordHint: "8 caractères minimum",
    consent: "J'accepte que des photos prises lors des VytaliDays soient utilisées par Vytali dans le cadre des activations.",
    activate: "Activer mon compte", invalidInvite: "Invitation invalide ou expirée",
  },
  nav: {
    home: "Accueil", events: "Événements", checkin: "Check-in", field: "Terrain", profile: "Profil",
    notifications: "Notifications", dashboard: "Tableau de bord", users: "Utilisateurs",
    teams: "Équipes", campaigns: "Campagnes", partners: "Partenaires", review: "Révision",
    reports: "Rapports", points: "Points", ledger: "Registre", leads: "Demandes partenaires",
    system: "Système", analytics: "Analytique", myQr: "Mon QR", outbox: "Leads événements",
  },
  qr: {
    title: "Mon QR personnel",
    lead: "Montrez ce code pendant une VytaliDay : chaque lead capté vous est attribué automatiquement.",
    download: "Télécharger", attribution: "Attribution automatique",
    autoAttributed: "Événement, partenaire et campagne attribués automatiquement.",
    noActiveEvent: "Aucun événement actif. Faites votre check-in pour activer l'attribution automatique — sinon la personne pourra choisir l'événement.",
    myLeads: "Mes leads captés", noLeads: "Aucun lead pour le moment.",
    manualTitle: "Lead manuel",
    manualCta: "Ajouter un lead manuellement",
    manualHint: "Pour une personne sans téléphone intelligent ou qui ne peut pas scanner le QR. Même attribution et même transmission vers VytaliLeads.",
    manualConsent: "La personne consent à être contactée par Vytali au sujet de sa demande.",
    manualSubmit: "Enregistrer le lead", manualSaved: "Lead enregistré et transmis",
    offlineNote: "Vous êtes hors ligne : le lead sera enregistré localement puis transmis dès le retour du réseau.",
    offlineQueued: "Lead enregistré — en attente de synchronisation",
    offlinePending: "En attente de synchronisation", offlineWaiting: "En attente de synchronisation",
    offlineSyncNow: "Synchroniser maintenant", offlineSynced: "{{n}} lead(s) synchronisé(s)",
    offlineNeedsEvent: "Choisissez l'événement pour attribuer ce lead avant la synchronisation.",
    offlineSyncNoEvent: "Synchroniser sans attribution", offlineError: "Échec : {{msg}}",
  },
  capture: {
    eyebrow: "VytaliDays", title: "Restons en contact",
    withAmbassador: "Avec {{name}}",
    firstName: "Prénom", lastName: "Nom", phone: "Téléphone", email: "Courriel",
    business: "Commerce / entreprise (facultatif)", interest: "Ce qui vous intéresse",
    notes: "Notes (facultatif)", chooseEvent: "Événement", noEvent: "Aucun événement",
    consent: "J'accepte d'être contacté par Vytali au sujet de ma demande.",
    submit: "Envoyer mes coordonnées",
    nameRequired: "Le prénom est requis",
    contactRequired: "Un courriel ou un téléphone est requis",
    consentRequired: "Votre consentement est requis",
    thanksTitle: "Merci !", thanksText: "Vos coordonnées ont été transmises. Un membre de l'équipe Vytali vous contactera bientôt.",
    invalid: "Ce code QR n'est pas valide.",
    privacy: "Vos données sont utilisées uniquement pour ce suivi.",
  },
  outbox: {
    title: "Leads événements", lead: "File de transmission des leads captés vers VytaliLeads.",
    flush: "Transmettre maintenant", export: "Export CSV (secours)", retry: "Réessayer",
    retried: "Nouvelle tentative lancée", flushed: "{{n}} livraison(s) traitée(s)",
    notConfigured: "Intégration VytaliLeads non configurée",
    notConfiguredHint: "L'API VytaliLeads n'est pas encore branchée : les leads sont conservés en file d'attente et seront transmis dès la configuration de l'URL et de la clé.",
    contact: "Contact", attribution: "Attribution", delivery: "Livraison",
    environment: "Environnement",
    blocked: "Transmission bloquée par la configuration : {{reason}}",
    externalId: "ID VytaliLeads", attempts: "Tentatives",
    attemptsTotal: "Tentatives (auto + manuelles)", manual: "manuelles",
    status: { pending: "En attente", sent: "Envoyé", confirmed: "Confirmé",
              failed: "Échec", retry: "À réessayer" },
  },
  fieldLeads: {
    title: "Leads du terrain", export: "Exporter les leads", total: "Total",
    qr: "QR autonome", manual: "Manuels", offline: "Hors ligne synchronisés",
    pending: "En attente de synchro", confirmed: "Confirmés VytaliLeads",
    exported: "Export généré", forbidden: "Ces leads sont hors de votre périmètre.",
  },
  report: {
    title: "Bilan d'activation", pdf: "Télécharger le PDF", reviewSend: "Réviser et envoyer",
    reviewSendHint: "Le bilan n'est jamais envoyé automatiquement. Vérifiez les chiffres avant de l'envoyer au partenaire.",
    confirmSend: "Envoyer au partenaire", messageOptional: "Message d'accompagnement (facultatif)",
    sent: "Bilan envoyé", ambassadors: "Ambassadeurs mobilisés", leads: "Leads générés",
    missions: "Missions complétées", content: "Contenus / preuves", summary: "Résumé des résultats",
    leadsDelivery: "Transmission vers VytaliLeads",
    lastSend: "Dernier envoi à {{email}} le {{date}}",
    forbidden: "Ce bilan est hors de votre périmètre.",
    loadError: "Le bilan n'a pas pu être chargé.",
    quotaExceeded: "Quota d'envoi quotidien Resend atteint. Réessayez demain ou augmentez votre limite Resend. Le PDF reste téléchargeable.",
    lastAttemptFailed: "Dernière tentative d'envoi à {{email}} le {{date}} — non livrée",
  },
  retention: {
    title: "Conservation des photos",
    lead: "Les photos de preuve sont supprimées automatiquement après {{days}} jours.",
    stored: "Stockées", expired: "Expirées", purgedTotal: "Purgées", days: "jours",
    purgeNow: "Purger maintenant", purged: "{{n}} photo(s) supprimée(s)",
    purgeErrors: "Échec de la purge de {{n}} photo(s) — voir les journaux",
    dailyJob: "Une purge automatique s'exécute chaque jour. Les métadonnées de mission et d'audit sont toujours conservées.",
  },
  analytics: {
    title: "Analytique", lead: "Performance par événement, équipe, Ambassadeur et partenaire.",
    all: "Tous", reset: "Réinitialiser", export: "Exporter CSV", events: "Événements",
    rsvps: "Inscriptions", attendanceRate: "Taux de présence", noShowRate: "Taux d'absence",
    approvedProofs: "Preuves approuvées", activeAmbassadors: "Ambassadeurs actifs",
    uniqueAmbassadors: "Ambassadeurs uniques", trend: "Présences par mois",
    topAmbassadors: "Meilleurs Ambassadeurs", viewHistory: "Historique",
    participationHistory: "Historique de participation",
    event: "Événement", recordedAt: "Enregistré",
    by: { events: "Événement", ambassadors: "Ambassadeur", teams: "Équipe",
          partners: "Partenaire", campaigns: "Campagne" },
  },
  system: {
    activeSupers: "Super administrateurs actifs", roleAudit: "Journal des rôles",
    activity: "Journal d'activité", nominate: "Nommer un super administrateur",
    nominateLead: "Choisissez un administrateur de confiance pour ne jamais perdre l'accès.",
    grant: "Promouvoir", revoke: "Rétrograder", supers: "Super administrateurs",
    leadStatus: { new: "Nouveau", contacted: "Contacté", qualified: "Qualifié", closed: "Fermé" },
  },
  account: {
    changeTitle: "Choisissez votre mot de passe",
    changeLead: "Pour sécuriser votre compte, définissez votre propre mot de passe avant de continuer.",
    currentPassword: "Mot de passe actuel", newPassword: "Nouveau mot de passe",
    confirmPassword: "Confirmer le mot de passe", savePassword: "Enregistrer le mot de passe",
    changed: "Mot de passe mis à jour", tooShort: "8 caractères minimum",
    mismatch: "Les mots de passe ne correspondent pas",
    forgotTitle: "Mot de passe oublié ?",
    forgotLead: "Nous vous enverrons un lien sécurisé de réinitialisation.",
    sendResetLink: "Envoyer le lien",
    resetSent: "Si un compte existe pour cette adresse, un courriel a été envoyé.",
    resetTitle: "Nouveau mot de passe", resetInvalid: "Lien invalide ou expiré",
  },
  home: {
    hello: "Bonjour", nextEvent: "Votre prochaine VytaliDay", noEvent: "Aucune VytaliDay à venir",
    noEventHint: "Vous serez averti dès qu'une activation sera planifiée.",
    checkInNow: "Faire mon check-in", myMissions: "Mes missions", progress: "Ma progression",
    attended: "Présences", missions: "Missions approuvées", score: "Score", pending: "En attente",
    viewEvent: "Voir l'événement", seeAll: "Tout voir",
  },
  events: {
    upcoming: "À venir", past: "Passées", detail: "Détail de l'événement", agenda: "Déroulé",
    objectives: "Objectifs", partner: "Partenaire", campaign: "Campagne", location: "Lieu",
    capacity: "Capacité", missions: "Missions", participants: "Participants",
    rsvp: "Confirmer ma présence", cancelRsvp: "Annuler ma présence", waitlisted: "Liste d'attente",
    rsvpConfirmed: "Présence confirmée", full: "Complet", shortCode: "Code court",
    consentRequired: "Consentement requis avant de confirmer", noEvents: "Aucun événement",
    eventUnavailable: "Cet événement n'est pas disponible pour vous en ce moment.",
    confirmedCount: "confirmés", checkedIn: "présents",
  },
  status: {
    confirmed: "Confirmé", waitlisted: "Liste d'attente", cancelled: "Annulé",
    no_show: "Absence", pending: "En attente", approved: "Approuvé", rejected: "Rejeté",
    draft: "Brouillon", published: "Publié", checked_in: "Présent", new: "Nouveau",
  },
  checkin: {
    title: "Check-in", scan: "Scanner le code QR", enterCode: "Entrer le code court",
    code: "Code de l'événement", validate: "Valider", success: "Présence enregistrée !",
    already: "Vous êtes déjà enregistré", offlineQueued: "Hors ligne — enregistré, synchronisation en attente",
    pendingSync: "check-in en attente de synchronisation", syncNow: "Synchroniser",
    pendingSyncNotice: "Check-in en attente de synchronisation : la soumission de preuve sera possible dès que le réseau revient.",
    stateConfirmed: "Présence confirmée", statePendingSync: "Check-in en attente de synchronisation",
    stateNone: "Aucun check-in",
    scannerMock: "Caméra indisponible ? Utilisez le code court.",
  },
  missions: {
    submitProof: "Soumettre une preuve", photo: "Photo", note: "Note", completion: "Marquer complété",
    reminder: "Rappel : contenu lié à l'événement seulement. Évitez les personnes identifiables sans leur consentement.",
    takePhoto: "Choisir une photo", noteLabel: "Votre note", submitted: "Preuve soumise — en attente de révision",
    resubmit: "Soumettre à nouveau", myProof: "Ma preuve", proofRemoved: "Photo retirée par un administrateur",
    objective: "Objectif", instructions: "Instructions", proofExpected: "Preuve demandée",
    deadline: "Échéance", required: "Obligatoire", optionalMission: "Facultative",
    viewDetail: "Voir le détail", openAndSubmit: "Voir le détail et soumettre",
    checkinFirst: "Faites votre check-in sur place pour pouvoir soumettre votre preuve.",
    expected_photo: "Une photo prise pendant l'événement.",
    expected_note: "Une note écrite décrivant ce que vous avez accompli.",
    expected_completion: "Une simple confirmation que la mission est complétée.",
  },
  progress: {
    title: "Ma progression", completed: "{{done}} / {{total}} missions complétées",
    pointsEarned: "Points gagnés", missionPoints: "{{n}} pts missions", attendancePoints: "{{n}} pts présence",
    potential: "En attente", potentialHint: "Non comptés avant approbation", todo: "À faire",
  },
  field: {
    title: "Mode Terrain", subtitle: "Tout ce dont vous avez besoin pendant l'activation.",
    doCheckin: "Faire mon check-in", captureLead: "Capturer un lead",
    showQr: "Afficher mon QR", addManual: "Ajouter manuellement",
    myMissions: "Mes missions", offlineMode: "Mode hors ligne",
    pendingActions: "Actions en attente de synchronisation",
    pendingCheckins: "{{n}} check-in(s) en attente", pendingLeads: "{{n}} lead(s) en attente",
    synced: "Synchronisation terminée", noEvent: "Aucune activation en cours.",
    noEventHint: "Faites votre check-in ou choisissez un événement depuis Mon QR.",
    chooseEvent: "Choisissez votre activation du jour :",
    syncBlocked: "{{n}} lead(s) n'ont pas pu être transmis",
    stuckLeads: "Un lead attend une attribution d'événement — ouvrez Mon QR pour le compléter.",
  },
  daySummary: {
    title: "Résumé de fin de journée", leaders: "Chef(s) d'équipe",
    live: "Activation en cours — les chiffres évoluent encore.",
    cancelled: "Cet événement est annulé.",
    attendance: "Présence", registered: "Inscrits", present: "Présents", noShow: "Absents",
    rate: "Taux de présence", missions: "Missions", missionsTotal: "Missions prévues",
    pendingReview: "En attente de révision", completion: "Taux de complétion",
    completionHint: "Approuvées / attendues", leads: "Leads",
    points: "Points distribués", pointsTotal: "Total", pointsManual: "Ajustements manuels",
    partnerReport: "Bilan partenaire", participants: "Participants",
    reviewQueue: "File de révision", generated: "Généré le",
    notCounted: "non comptées", notConfirmed: "non confirmés",
  },
  review: {
    queue: "File de révision", needsReview: "À réviser", approve: "Approuver", reject: "Rejeter",
    rejectReason: "Raison du rejet", empty: "Rien à réviser — tout est à jour",
    attendance: "Présences", markPresent: "Marquer présent", markNoShow: "Marquer absent",
    removePhoto: "Retirer la photo", reviewed: "Révisé",
  },
  admin: {
    invite: "Inviter", inviteUser: "Inviter un utilisateur", role: "Rôle", name: "Nom",
    team: "Équipe", newEvent: "Nouvel événement", newCampaign: "Nouvelle campagne",
    newTeam: "Nouvelle équipe", newPartner: "Nouveau partenaire", newMission: "Nouvelle mission",
    attendancePoints: "Points de présence", missionPoints: "Points par mission",
    retention: "Conservation des images (jours)", adjustScore: "Ajuster le score",
    inviteCreated: "Invitation créée", inviteLink: "Lien d'invitation",
    super_admin: "Super administrateur", admin: "Administrateur",
    team_leader: "Chef d'équipe", ambassador: "Ambassadeur",
    globalConfig: "Configuration des points", manualAdjust: "Ajustement manuel",
    socialImage: "Image sociale — URL 1200 × 630",
  },
  profile: {
    title: "Profil", myScore: "Mon score", history: "Historique",
    prefsEmail: "Recevoir les courriels", ledger: "Registre de points", noShows: "Absences",
  },
  notif: { title: "Notifications", empty: "Aucune notification", markAll: "Tout marquer comme lu" },

  pub: {
    nav: { home: "Accueil", events: "Événements", partners: "Partenaires", about: "À propos", login: "Connexion" },
    eyebrow: "Personnes • Partenaires • Communauté • Croissance",
    heroTitle: "Des activations qui créent du mouvement.",
    heroText: "VytaliDays rassemble Ambassadeurs, partenaires, commerces et communautés autour d'expériences terrain conçues pour créer visibilité, engagement, nouvelles relations et opportunités de croissance.",
    ctaEvents: "Voir les prochains VytaliDays",
    ctaPartner: "Devenir partenaire",
    ctaPartnerVytali: "Devenir partenaire Vytali",
    strategic: "VytaliDays transforme les événements terrain en opportunités de croissance pour les personnes, les commerces et les communautés.",
    whatTitle: "Plus qu'un événement.",
    whatLead: "VytaliDays crée de la valeur avant, pendant et après chaque activation.",
    pillars: {
      ambassadors: { title: "Ambassadeurs", text: "Des personnes mobilisées pour créer des interactions, représenter les campagnes et faire vivre l'expérience sur le terrain." },
      partners: { title: "Partenaires", text: "Des commerces et entrepreneurs qui bénéficient de visibilité, d'activations, de contenu et de nouvelles opportunités." },
      community: { title: "Communauté", text: "Des participants et membres qui découvrent de nouvelles personnes, entreprises et expériences au sein de l'écosystème Vytali." },
      growth: { title: "Croissance", text: "Chaque activation peut contribuer à créer de nouveaux membres, des leads, des relations commerciales, du contenu et de la fidélisation." },
    },
    phasesTitle: "Une activation qui commence avant l'événement.",
    phases: {
      before: { label: "Avant", items: ["promotion du commerce partenaire", "contenu et publications", "invitations", "mobilisation des Ambassadeurs", "préparation de la campagne", "visibilité autour du VytaliDay"] },
      during: { label: "Pendant", items: ["présence des Ambassadeurs", "interactions avec les participants", "activation du partenaire", "création de contenu", "génération de leads", "inscriptions", "expérience communautaire"] },
      after: { label: "Après", items: ["suivi des opportunités", "conversion commerciale", "contenu post-événement", "analyse des résultats", "développement de la relation partenaire", "préparation des prochaines activations"] },
    },
    upcomingTitle: "Prochains VytaliDays",
    upcomingLead: "Découvrez les activations à venir dans votre région.",
    viewEvent: "Voir l'événement",
    noEvents: "De nouveaux VytaliDays arrivent bientôt.",
    allEvents: "Tous les VytaliDays",
    pastEvents: "Activations passées",
    partnerTitle: "Votre commerce au cœur d'un prochain VytaliDay.",
    partnerText: "VytaliDays permet aux commerces et entrepreneurs partenaires de bénéficier d'une activation complète autour de leur entreprise : visibilité avant l'événement, présence terrain, contenu, interactions, génération d'opportunités et suivi après l'activation.",
    partnerBenefits: ["Visibilité locale", "Promotion avant l'événement", "Activation par les Ambassadeurs", "Contenu photo et vidéo", "Génération d'opportunités", "Exposition à la communauté Vytali", "Engagement de la clientèle", "Mesure des résultats"],
    retention: "Un partenariat. Plusieurs activations. Une visibilité continue.",
    businessTypes: { restaurant: "Restaurant", cafe: "Café", retail: "Commerce de détail", gym: "Gym / sport", beauty: "Beauté / soins", services: "Services", other: "Autre" },
    formTitle: "Parlons de votre prochaine activation",
    formLead: "Remplissez ce formulaire et l'équipe Vytali vous contactera.",
    form: {
      firstName: "Prénom", lastName: "Nom", business: "Nom du commerce", email: "Courriel",
      phone: "Téléphone", city: "Ville", businessType: "Type de commerce",
      language: "Langue préférée", message: "Message",
      goal: "Qu'aimeriez-vous développer ou améliorer ?",      consent: "J'accepte d'être contacté par Vytali au sujet de ma demande.",
      send: "Envoyer ma demande",
      success: "Merci ! Votre demande a été reçue. L'équipe Vytali vous contactera bientôt.",
      error: "L'envoi a échoué. Veuillez réessayer.",
      requiredField: "Ce champ est requis",
      invalidEmail: "Courriel invalide",
      consentRequired: "Votre consentement est requis",
    },
    ambassadorTitle: "Les Ambassadeurs font vivre VytaliDays.",
    ambassadorText: "Les Ambassadeurs sont la couche humaine de chaque activation : ils créent les interactions, portent les campagnes et transforment un événement en expérience.",
    ambassadorPoints: ["Expérience terrain", "Missions concrètes", "Développement personnel", "Formation", "Réseautage", "Progression", "Génération d'opportunités", "Participation à la communauté"],
    ambassadorCta: "Connexion Ambassadeur",
    ambassadorNote: "L'accès Ambassadeur se fait sur invitation.",
    communityTitle: "Une communauté qui grandit à chaque événement.",
    communityText: "Chaque VytaliDay crée de nouvelles rencontres et de nouvelles connexions. Avec le temps, ces interactions contribuent à développer une communauté Vytali composée de membres, d'Ambassadeurs, de partenaires et d'entrepreneurs qui peuvent créer de la valeur les uns pour les autres.",
    communityTags: ["Membres", "Participants", "Ambassadeurs", "Commerces partenaires", "Employés partenaires", "Entrepreneurs"],
    activationTitle: "Des interactions qui deviennent des opportunités.",
    activationText: "Chaque activation génère des interactions, des inscriptions, des opportunités qualifiées, des références et de l'engagement partenaire.",
    flixTitle: "Chaque partenaire a une histoire de croissance.",
    flixLine: "VytaliFlix capte la vision. VytaliDays met la vision en mouvement.",
    flixText: "VytaliFlix peut documenter où en est un partenaire aujourd'hui, ce que l'entrepreneur souhaite changer, ce qu'il espère accomplir dans les six prochains mois et quelles sont ses attentes. VytaliDays devient ensuite l'un des moments d'activation concrets qui met cette vision en mouvement. Avec le temps, Vytali peut documenter l'évolution du partenaire.",
    flixCta: "Découvrir VytaliFlix",
    flixSoon: "VytaliFlix — bientôt disponible",
    finalTitle: "Prêt à faire partie du prochain mouvement?",
    aboutTitle: "À propos de VytaliDays",
    aboutLead: "VytaliDays est la plateforme d'activation terrain de Vytali : des expériences réelles qui rassemblent des personnes, des commerces et des communautés.",
    aboutHow: "Comment ça fonctionne",
    aboutSteps: [
      { title: "Une campagne", text: "Vytali définit une campagne d'activation avec ses objectifs et son commerce partenaire." },
      { title: "Un VytaliDay", text: "Un événement terrain est planifié : lieu, horaire, déroulé, missions et Ambassadeurs assignés." },
      { title: "L'activation", text: "Les Ambassadeurs créent des interactions, du contenu et des opportunités sur place." },
      { title: "Le suivi", text: "Les résultats sont mesurés et alimentent la relation partenaire et les prochaines activations." },
    ],
    footerTagline: "Une expérience Vytali",
    footerPrivacy: "Confidentialité", footerTerms: "Conditions", footerContact: "Contact",
    shareOn: "Partager sur",
  },
};

export default fr;
